export default __webpack_public_path__ + "static/media/noFloorPlan.bdc46e06.png";